import * as _m0 from "protobufjs/minimal";
import { SubmitCaseRequest, SubmitCaseResponse } from '../submitcase';
import { withAuthRetry } from '../utils/authRetry';

export async function submitcase(request: SubmitCaseRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<SubmitCaseResponse> {
    // Check for mockSubmission parameter to bypass backend call
    const params = new URLSearchParams(window.location.search);
    const mockSubmission = params.get('mockSubmission')?.toLowerCase() === 'true';

    if (mockSubmission) {
        console.log('Mock submission enabled, returning mock response for submitcase');
        // This is the raw base64-encoded protobuf response bytes captured from the network
        const mockBase64Response = 'CiQ5NzFhMTAwMy0wMTcxLTRhYTctODlmNy1lYjE3MzFmYTRmNmE=';
        // Decode base64 to bytes, then decode protobuf
        const bytes = new Uint8Array(_m0.util.base64.length(mockBase64Response));
        _m0.util.base64.decode(mockBase64Response, bytes, 0);
        return SubmitCaseResponse.decode(bytes);
    }

    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';
        request.isStaging = staging; // Keep this specific logic

        const encodedRequest = SubmitCaseRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/submitcase";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers,
            body: base64,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): SubmitCaseResponse => {
        return SubmitCaseResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}